export default __webpack_public_path__ + "static/media/commentNote.8076dc03.svg";